/** Les conditions, leur consentement, et les mises a jour. */
export const legal = {
  documents: {
    cgu: 'Conditions générales d’utilisation',
    confidentialite: 'Politique de confidentialité',
    mentions: 'Mentions légales',
    version: (v: string) => `Version ${v}`,
  },
  consentement: {
    titrePlusieurs: 'NOS DOCUMENTS ONT CHANGÉ',
    titreUn: 'UN DOCUMENT A CHANGÉ',
    textePlusieurs: 'Pour continuer à utiliser Sirocco, prends connaissance des deux documents ci-dessous et accepte-les.',
    texteUn: 'Pour continuer à utiliser Sirocco, prends connaissance du document ci-dessous et accepte-le.',
    accepter: 'Accepter et continuer',
    deconnecter: 'Se déconnecter',
  },
  ecran: {
    resumeCgu: 'Ce que tu acceptes en utilisant Sirocco.',
    resumeConfidentialite: 'Quelles données sont collectées, pourquoi, et combien de temps.',
    resumeMentions: 'Qui édite l’application, qui l’héberge, comment nous joindre.',
    titre: 'Conditions et confidentialité',
    accepte: (cgu: string, confidentialite: string, quand: number | null) =>
    `Tu as accepté les conditions générales en version ${cgu} et la politique de confidentialité en version ${confidentialite}${quand ? `, le ${new Date(quand).toLocaleDateString('fr-FR')}` : ''}.`,
  },
  lien: {
    impossible: 'Impossible d’ouvrir la page. Voici l’adresse :',
  },
  miseAJour: {
    texte: 'Cette version apporte des changements que l’application ne peut pas se donner toute seule.',
    plusTard: 'Plus tard',
    mettreAJour: 'Mettre à jour',
    disponible: (version: string) => `Sirocco ${version} est disponible`,
  },
};
